// React
import { ReactElement } from 'react';
// Modules
import classNames from 'classnames/bind';
// Design System
import { Skeleton } from '@utmb/design-system/placeholder/Placeholder';
// Interfaces
import { MyUTMBBrandProps } from '@utmb/types/my-utmb-brand';
// Styles
import stylesBrand from './brand.module.scss';
import styles from './brand-skeleton.module.scss';

const cx = classNames.bind(stylesBrand);

const BrandSkeleton = (props: MyUTMBBrandProps): ReactElement => {
    const { inMenu, inContent } = props;

    const brandWrapperCSS = cx(stylesBrand.wrapper, {
        inMenu,
        inContent,
    });
    const titleCSS = cx(stylesBrand.title, styles.skeleton);

    return (
        <div className={brandWrapperCSS}>
            <div className={titleCSS}>
                <Skeleton className={styles.skeleton_brand} width="60%" height="40" />
                <Skeleton className={styles.skeleton_icon} width="15%" height="40" />
            </div>
        </div>
    );
};

export default BrandSkeleton;
